import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, submit, Field, reset, getFormSubmitErrors, isInvalid, change } from 'redux-form'
import FilterByPeriod from '../../../../modules/FilterByPeriod/FilterByPeriod'
import FilterByWeekDays from '../../../../modules/FilterByWeekDays/FilterByWeekDays'
import FilterByTag from '../FilterByTag/FilterByTag'
import PaginationSelector from '../PaginationSelector/PaginationSelector'
import FilterByType from './FilterByType/FilterByType'
import ShowResultsForm from './ShowResultsForm'

import {
  ButtonsContainer,
  FormButton,
  ResetButton,
  Grid,
  FormsContainer,
  InputsContainer,
  Separator,
  ShowResultsBtnWrapper
} from './styles'

const filterItems = [
  {
    value: 15,
    label: '15 dias'
  },
  {
    value: 30,
    label: '30 dias'
  },
  {
    value: 60,
    label: '60 dias'
  },
  {
    value: 90,
    label: '90 dias'
  },
  {
    value: 180,
    label: '180 dias'
  },
  {
    value: 0,
    label: 'Período específico'
  }
]

const FormInputs = ({ handleSubmit, setTypeRef, setWeekDayRef }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field name="plate" component="input" type="hidden" />
      <FilterByType setTypeRef={setTypeRef} />
      <Separator />
      <FilterByPeriod options={filterItems} rangeForValidation={180} />
      <Separator />
      <FilterByWeekDays setWeekDayRef={setWeekDayRef} />
      <Separator />
      <PaginationSelector />
    </form>
  )
}

const BeforeResultsForm = reduxForm({
  form: 'statementsFilter',
  destroyOnUnmount: false
})(
  connect(state => ({
    accountPlans: state.reducer.accountPlans
  }))(FormInputs)
)

let RemoteSubmitButton = ({ dispatch, invalid, plateIsValid }) => {
  return (
    <FormButton
      onClick={() => dispatch(submit('statementsFilter'))}
      disabled={invalid || !plateIsValid}
      invalid={invalid || !plateIsValid}
      type="submit"
    >
      Aplicar filtros
    </FormButton>
  )
}
RemoteSubmitButton = connect()(RemoteSubmitButton)

class PartnerFilterForm extends Component {
  state = {
    weekRefs: [],
    typeRefs: [],
    loading: false,
    plateIsValid: false
  }

  unsetFilterByWeekDays = () => {
    this.state.weekRefs.map(ref => {
      ref.checked = false
    })
    this.setState({ weekRefs: [] })
  }

  setWeekDayRef = ref => this.setState({ weekRefs: [...this.state.weekRefs, ref] })

  unsetFilterByType = () => {
    this.state.typeRefs.map(ref => {
      ref.checked = false
    })
    this.setState({ typeRefs: [] })
  }

  setPlateValidation = bool => {
    this.setState({ plateIsValid: bool })
  }
  setLoading = bool => this.setState({ loading: bool })

  setTypeRef = ref => this.setState({ typeRefs: [...this.state.typeRefs, ref] })

  render() {
    const {
      onSubmitFilter,
      showResults,
      dispatch,
      unsetResults,
      plateFormError,
      plateFormIsInvalid
    } = this.props
    const { plateIsValid, loading } = this.state
    const invalid = plateFormError || plateFormIsInvalid
    return (
      <FormsContainer>
        <InputsContainer>
          <FilterByTag
            setPlateValidation={this.setPlateValidation}
            plateIsValid={plateIsValid}
            setLoading={this.setLoading}
            loading={loading}
          />
          {!showResults && <Separator />}
          {showResults ? (
            <ShowResultsForm />
          ) : (
            <BeforeResultsForm
              onSubmit={onSubmitFilter}
              setTypeRef={this.setTypeRef}
              setWeekDayRef={this.setWeekDayRef}
            />
          )}
        </InputsContainer>

        {showResults ? (
          <ShowResultsBtnWrapper>
            <ResetButton
              showResults={showResults}
              onClick={e => {
                e.preventDefault()
                unsetResults()
                this.unsetFilterByWeekDays()
                dispatch(reset('statementsFilter'))
                dispatch(change('checkPlateOrIdForm', 'validPlate', ''))
                dispatch(change('checkPlateOrIdForm', 'identificador', ''))
                this.setPlateValidation(false)
              }}
            >
              Remover filtros
            </ResetButton>
          </ShowResultsBtnWrapper>
        ) : (
          <ButtonsContainer>
            <Grid>
              <ResetButton
                onClick={e => {
                  e.preventDefault()
                  unsetResults()
                  this.unsetFilterByWeekDays()
                  dispatch(reset('statementsFilter'))
                  dispatch(change('checkPlateOrIdForm', 'validPlate', ''))
                  dispatch(change('checkPlateOrIdForm', 'identificador', ''))
                  this.setPlateValidation(false)
                }}
              >
                Remover filtros
              </ResetButton>

              <RemoteSubmitButton invalid={invalid} plateIsValid={plateIsValid} />
            </Grid>
          </ButtonsContainer>
        )}
        <Separator />
      </FormsContainer>
    )
  }
}

export default connect(state => ({
  plateFormError: getFormSubmitErrors('checkPlateOrIdForm')(state),
  plateFormIsInvalid: isInvalid('checkPlateOrIdForm')(state)
}))(PartnerFilterForm)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/PartnerFilterForm.js